import { StyleSheet } from 'react-native';
import { TOP_BAR_TOTAL_HEIGHT } from '../../../runtime/Navigation/Menu/Menu.styles';
import Theme from 'Theme';

let baseStyles = {
    container: {
        overflow: 'visible',
        // paddingBottom: Theme.primaryPaddingBottom,
        paddingTop: TOP_BAR_TOTAL_HEIGHT,
        width: 500,
        flexGrow: 0
        // paddingHorizontal: Theme.primaryMargin
    },
    carousel: {
        marginTop: 30,
        width: '100%'
    },
    promoCarousel: {
        marginBottom: 20,
        height: 409
    }
};

baseStyles = {
    ...baseStyles,
    tvGuideButton: {
        alignSelf: 'flex-end'
    }
};

export default StyleSheet.create(baseStyles);
